<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Yönetim Paneli</a>
      <div class="collapse navbar-collapse justify-content-end">
        <!--<ul class="nav navbar-nav mr-auto">
          <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Bildirim 1</a>
            <a class="dropdown-item" href="#">Bildirim 2</a>
            <a class="dropdown-item" href="#">Bildirim 3</a>
            <a class="dropdown-item" href="#">Bildirim 4</a>
          </base-dropdown>
        </ul>-->
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-if="userEmail">
            <span class="user-email-badge">{{ userEmail }}</span>
          </li>
          <li class="nav-item">
            <a-popconfirm
              @confirm="confirmLogout"
              title="Çıkış yapmak istediğinize emin misiniz?" 
              ok-text="Evet" 
              cancel-text="Hayır">
              <a href="#" class="nav-link">
                Log out
              </a>
            </a-popconfirm>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<style scoped>
  .user-email-badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 14px;
    margin-right: 8px;
    background-color: #f4f4f5;
    border: 1px solid #e0e0e0;
    border-radius: 20px;
    color: #66615b;
    font-size: 13px;
    line-height: 1;
  }
</style>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      },
      userEmail () {
        const user = JSON.parse(localStorage.getItem("user") || "null")
        return user ? user.email : null
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      confirmLogout(){
        localStorage.clear();
        var tm = setTimeout(()=> {
          location.reload()
          clearTimeout(tm)
        }, 200)
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    }
  }

</script>
<style>

</style>
